
import { Typography } from "@mui/material";

export default function StatusEntrada({ status, origem }) {

    const Origem = origem ? <span style={{ fontSize: 10, color: '#000', marginLeft: 5, background: '#fff', padding: '2px 4px', borderRadius: 3 }}>({origem})</span> : null;

    return (
        <>
            {status === 'Licenciamento' &&
                <Typography noWrap style={{ borderRadius: 5, background: '#f3d194', color: '#000', padding: 5 }} align="center" variant="subtitle2">
                    {status?.toUpperCase()}
                    {Origem}
                </Typography>
            }

            {status === 'Renovação' &&
                <Typography noWrap style={{ borderRadius: 5, background: '#85287d8a', color: '#fff', padding: 5 }} align="center" variant="subtitle2">
                    {status?.toUpperCase()}
                    {Origem}
                </Typography>
            }
        </>
    )
}